import React, {useState} from 'react'
import {
  styled,
  TextField as MuiTextField,
} from '@material-ui/core'
import {useEditApplication} from 'lms/hooks'

const Heading = styled('h4')(({theme}) => ({
  margin: 0,
  marginTop: 24,
  marginBottom: 6,
  fontSize: 18,
  fontWeight: 500,
  color: theme.palette.text.secondary,
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

const Grid = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gridColumnGap: 20,
})

const ContactInfo = (props) => {
  const [application, updateApplication] = useEditApplication()
  const {contact={}} = application
  const [calendarUrlError, setCalendarUrlError] = useState(false)

  const updateContact = (change) => updateApplication({contact: {...contact, ...change}})

  const handleCalendarUrlChange = (e) => {
    const value = e.target.value
    const isValid = !value || /^https?:\/\/.+/.test(value)
    setCalendarUrlError(!isValid)
    if (isValid) updateContact({calendarUrl: value})
  }

  return (
    <>
      <Heading>Contact Person</Heading>
      <Grid>
        <MuiTextField
          defaultValue={contact.fullName}
          label="Contact Name"
          variant="outlined"
          margin="dense"
          onChange={(e) => updateContact({fullName: e.target.value})}
        />
        <MuiTextField
          defaultValue={contact.jobPosition}
          label="Job Position"
          variant="outlined"
          margin="dense"
          onChange={(e) => updateContact({jobPosition: e.target.value})}
        />
        <MuiTextField
          defaultValue={contact.email}
          label="Email"
          variant="outlined"
          margin="dense"
          onChange={(e) => updateContact({email: e.target.value})}
        />
        <MuiTextField
          defaultValue={contact.phone}
          label="Phone"
          variant="outlined"
          margin="dense"
          onChange={(e) => updateContact({phone: e.target.value})}
        />
        <MuiTextField
          defaultValue={contact.calendarUrl}
          label="Calendar URL"
          variant="outlined"
          margin="dense"
          style={{gridColumn: '1 / -1'}}
          error={calendarUrlError}
          helperText={calendarUrlError ? 'Must be a valid http or https URL' : 'Link to your scheduling page, e.g. Calendly or HubSpot Meetings'}
          onChange={handleCalendarUrlChange}
        />
      </Grid>
    </>
  )
}

export default ContactInfo
